import { render } from "./ControlError.vue?vue&type=template&id=4bc6ff04"
import script from "./ControlError.vue?vue&type=script&lang=js"
export * from "./ControlError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__